import {LicenseInfo} from "@mui/x-data-grid-pro";



export function setLicenseKeys() {
    // License key MUI
    LicenseInfo.setLicenseKey(
        '3660b31bf571bd3cac78fb547d6e068bT1JERVI6NDAxMDEsRVhQSVJZPTE2Nzk0NzkwMTkwMDAsS0VZVkVSU0lPTj0x',
    );
}